// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#yardi-connect {
  padding-top: 15px;
}
#accountId {
  margin-top: 5px !important;
}
.holder {
  background: white;
  padding-left: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared-components-module/integrations/yardi/yardi-integration-pane/yardi-integration-pane.component.less"],"names":[],"mappings":"AAEA;EACI,iBAAA;AADJ;AAIA;EACI,0BAAA;AAFJ;AAKA;EACI,iBAAA;EACA,kBAAA;AAHJ","sourcesContent":["@import (reference) url('../../../../../styles.less');\n\n#yardi-connect {\n    padding-top: 15px;\n}\n\n#accountId {\n    margin-top: 5px !important;\n}\n\n.holder {\n    background: white;\n    padding-left: 15px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
